import React, { useState } from 'react'
import { breakpoints } from '@grammarly/badger-ui'

import { TypeSectionGroup } from '../../../lib/types'
import { ContentProps } from '../../renderer'
import { PageSection } from '../../page-section'
import { isTypeSectionTwoColumn } from '../../../lib/types/content-types'
import { ParallaxContainerProvider } from '../../../contexts/parallax-context'
import { FeatureHighlightProvider } from '../../../contexts/feature-highlight-context'
import { useBrowserService, useMediaQuery } from '../../../lib/hooks'
import { noop } from '../../../lib/utils/noop'

import { ParallaxDesktop } from './desktop'
import { ParallaxResponsive } from './responsive'

export const SectionParallax: React.FC<ContentProps<TypeSectionGroup>> = ({ className, structure }) => {
  const isScreenWidthSmall = useMediaQuery(`(max-width: ${breakpoints.small})`)
  const { isMobile } = useBrowserService()
  const isStackedModeActive = isMobile || isScreenWidthSmall // check both `isMobile` in addition to `isScreenWidthSmall` as `isMobile` is captured in SSR and reduces CLS
  const [activeSlideIndex, setActiveSlideIndex] = useState(-1)

  const {
    sys,
    fields: { internalName, background, heading, rows = [] },
  } = structure

  const eligibleRows = rows
    .filter(isTypeSectionTwoColumn)
    .filter((section) => !!section.fields.leftColumnContent && !!section.fields.rightColumnContent)

  return (
    <ParallaxContainerProvider value={{ containerName: internalName, activeSlideIndex }}>
      <PageSection
        internalName={internalName}
        sysStructure={sys}
        className={className}
        heading={heading}
        background={background}
        overrideOnFirstEnterViewport={noop}
      >
        <FeatureHighlightProvider value={{ titleStyle: 'HL' }}>
          {isStackedModeActive ? (
            <ParallaxResponsive
              containerInternalName={internalName}
              content={eligibleRows}
              setActiveSlideIndex={setActiveSlideIndex}
            />
          ) : (
            <ParallaxDesktop
              containerInternalName={internalName}
              content={eligibleRows}
              activeSlideIndex={activeSlideIndex}
              setActiveSlideIndex={setActiveSlideIndex}
            />
          )}
        </FeatureHighlightProvider>
      </PageSection>
    </ParallaxContainerProvider>
  )
}
